(function ($) {
    var break_point = 768;
    var browser_width = window.innerWidth;
    var button = $('#inpagenavButton');
    var list = $('#inpagenavList');

    if (list.length) {
        if (browser_width < break_point) {
            button.on("click", function () {
                button.toggleClass('__active');
                list.slideToggle();
            });
            list.find("a").on("click", function () {
                list.slideUp();
                button.removeClass('__active');
            });
        }
    }
})(jQuery);